import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { BspEdit, BspService } from '@app/services/bsp.service';

@Component({
  selector: 'tt-bsp',
  templateUrl: './bsp.component.html',
  styleUrls: ['./bsp.component.css'],
  standalone: false,
})
export class BspComponent implements OnInit {
    public params?: { bsp_keyno: string };

    public page?: BspEdit;

    public saving = false;

    constructor(
        private bsp: BspService,
        private modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public async save(): Promise<void> {
        if (!this.page) return;

        this.saving = true;

        try {
            const response = await this.bsp.save(this.page);

            if (response.errorcode !== '0') {
                await this.modal.show({
                    type: 'warning',
                    title: 'error',
                    translateTitle: true,
                    message: response.errormessage
                });

                return;
            }

            await this.navigator?.back();
        } finally {
            this.saving = false;
        }
    }

    public async ngOnInit(): Promise<void> {
        const routeParams = this.navigator?.params as { bsp_keyno?: string } | undefined;
        const keyno = this.params?.bsp_keyno ?? routeParams?.bsp_keyno;

        if (keyno !== undefined) this.page = await this.bsp.getEdit(keyno);
    }
}
